import copyToClipboard from './copy-to-clipboard-func'

const applyShareBtnHandling = (shareBtnWrapperElements, url) => {
  let currentUrl = url || window.location.href;
  let timer = null;

  const hidePopupAfterTimeOut = (shareBtn) => {
    if(shareBtn.classList.contains('share-btn-wrapper_popup')) {
      timer = setTimeout(() => {
        shareBtn.classList.remove('share-btn-wrapper_popup');
      }, 3000)
    }
  }

  shareBtnWrapperElements.forEach((itm) => {
    const shareBtn = itm.querySelector('.share-btn');
    const copyBtn = itm.querySelector('.share-btn-wrapper__copy-link-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', async () => {
        if (navigator.share && window.innerWidth < 768) {
          await navigator.share({
            url: currentUrl,
          });
        } else {
          itm.classList.toggle('share-btn-wrapper_popup');
        }
        itm.querySelectorAll('.share-btn-wrapper__item').forEach((item) => {
          item.addEventListener('click', () => {
            itm.classList.remove('share-btn-wrapper_popup');
            const shareUrlElement = document.querySelector('.content-clipboard');
            if (shareUrlElement) {
              copyToClipboard(currentUrl)
            }
          });
        });
      })
    }
    if (copyBtn) {
      copyBtn.addEventListener('click', () => {
        copyToClipboard(currentUrl);
        copyBtn.classList.add('share-btn-wrapper__copy-link-btn_active');
        setTimeout(() => {
          copyBtn.classList.remove('share-btn-wrapper__copy-link-btn_active');
        }, 2000);
      })
    }

    itm.addEventListener('mouseenter', () => {
      clearTimeout(timer)
    });

    itm.addEventListener('mouseleave', () => hidePopupAfterTimeOut(itm));
  });
  
  document.body.addEventListener('click', (e) => {
    if (!e.target.closest('.share-btn-wrapper')) {
      shareBtnWrapperElements.forEach((item) => {
        item.classList.remove('share-btn-wrapper_popup');
      })
    }
  });
}
window.applyShareBtnHandling = applyShareBtnHandling;

document.addEventListener('DOMContentLoaded', function () {
  const shareBtnWrapperElements = document.querySelectorAll('.share-btn-wrapper');
  applyShareBtnHandling(shareBtnWrapperElements, window.location.href);
});